import {once} from 'lodash';
import {QueryClient} from '@tanstack/react-query';

export const getQueryClient = once(() => new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 0
    }
  }
}));
